import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import LangLink from '../../components/common/LangLink';
import AuthLayout, { AUTH_BUTTON_CLASS } from './AuthLayout';

export default function SignupSuccess() {
    const { language } = useLanguage();
    const fr = language === 'fr';

    return (
        <AuthLayout
            title={fr ? 'Vérifiez vos courriels' : 'Check your email'}
            subtitle={fr
                ? 'Un lien de confirmation a été envoyé à votre adresse courriel. Veuillez cliquer dessus pour activer votre compte.'
                : 'A confirmation link has been sent to your email address. Please click it to activate your account.'}
            footer={
                <LangLink to="/" className="block text-sm text-[#0061FE] dark:text-[#71a7ff] hover:text-[#0052db] dark:hover:text-white font-medium transition">
                    {fr ? '← Retour à l\'accueil' : '← Back to home'}
                </LangLink>
            }
        >
            {/* Success icon */}
            <div className="w-16 h-16 bg-green-50 dark:bg-green-500/15 border border-green-200 dark:border-green-500/30 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
            </div>

            <LangLink to="/login" className={AUTH_BUTTON_CLASS}>
                {fr ? 'Aller à la connexion' : 'Go to login'}
            </LangLink>
        </AuthLayout>
    );
}
